import React, { useState, useCallback } from "react";
import HeaderTable from "./headerTable";
import BodyTable from "./bodyTable";
import Pagination from "../../../../components/Pagination";

function TableComplainWages({
  data,
  onChange,
  totalPage,
  handleOnChangePage,
  pageNumber,
  limitDataPages,
  startDate,
  endDate,
  getNewData,
}) {
  const [payload, setpayload] = useState({
    sortBy: null,
    sortType: null,
    amount: 0,
    deduction: null,
    deductionNote: null,
  });

  const handleChangePage = useCallback(
    ({ selected }) => {
      const page = selected + 1;
      handleOnChangePage({ value: page });
    },
    [handleOnChangePage]
  );

  const handleHeaderChange = (updates) => {
    setpayload((prev) => ({
      ...prev,
      ...updates,
    }));

    onChange?.({
      ...payload,
      ...updates,
    });
  };

  return (
    <div className="flex flex-column justify-content-between align-items-center w-full h-full border-1 border-solid border-100 border-round-sm">
      <div className="flex flex-column justify-content-start align-items-start w-full overflow-x-auto">
        {/* Header Table Row */}
        <div
          className="flex flex-row justify-content-between align-items-center max-w-max min-w-full w-max h-auto border-bottom-1 border-100 z-5"
          style={{ position: "sticky", top: 0, background: "#f8f8f8" }}
        >
          <HeaderTable data={data} onChange={handleHeaderChange} />
        </div>

        {/* Body Table Rows */}
        <div
          className="flex flex-column justify-content-start align-items-center max-w-max min-w-full w-max h-auto max-h-full"
          style={{ minHeight: "225px" }}
        >
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <div
                key={index}
                className={`flex flex-row justify-content-between align-items-center w-full h-full 
          ${index % 2 !== 0 ? "bg-gray-100" : ""} 
          ${index !== data.length - 1 || data.length <= 6 ? "border-bottom-1 border-200" : ""}`}
              >
                <BodyTable
                  data={item}
                  index={index}
                  pageNumber={pageNumber}
                  limitDataPages={limitDataPages}
                  getNewData={getNewData}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
            ))
          ) : (
            <div
              className="p-3 text-center text-muted flex flex-row justify-content-center align-items-center p-0 m-0"
              style={{
                minHeight: "max-content",
                position: "absolute",
                top: "70%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <h5 className="m-0 p-0">Tidak ada data</h5>
            </div>
          )}
        </div>
      </div>
      {totalPage > 0 && (
        <div className="flex flex-row justify-content-center align-items-center w-full h-5rem border-top-1 border-200 p-0 m-0">
          {totalPage > 0 && <Pagination pageCount={totalPage} forcePage={pageNumber - 1} changePage={handleChangePage} />}
        </div>
      )}
    </div>
  );
}

export default TableComplainWages;
